import { useEffect } from "react";
import { RetirementTable } from "./RetirementBody";
import { Column } from "./RetirementBody/Column";
import { useTranslation } from "react-i18next";

import { TableFilter } from "./RetirementBody/TableFilter";
import { useQueries } from "@hooks/useQueries";
import { useRetirementReports } from "@hooks/HRM/reports/useRetirementReports";

export const Retirement = () => {
  const { t } = useTranslation();
  const { handleQuery, getRetirementData } = useRetirementReports();

  const { setSearchParams } = useQueries();

  useEffect(() => {
    setSearchParams(undefined);
  }, []);

  return (
    <div className="pt-10">
      <TableFilter handleQuery={handleQuery} />
      <RetirementTable column={Column(t)} rows={getRetirementData || []} />
    </div>
  );
};

export { RetirementPageHeader } from "./RetirementPageHeader";
